import { render, staticRenderFns } from "./Returnable.vue?vue&type=template&id=2522f069&"
import script from "./Returnable.vue?vue&type=script&lang=js&"
export * from "./Returnable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports